<template>
  <div
    :class="[isImageModalShown ?'d-none':'' ]"
    class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed">
    <div class="modal-inner align-items-center justify-content-center d-flex h-100 w-100">
      <div
        class="bm-image-modal-content im-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Add Image">
        <div class="im-header">
          <h2 class="modal-heading">Add Image</h2>
          <button
            type="button"
            class="im-close"
            aria-label="Close"
            title="Close"
            @click="handleModalClose">
            <icon name="close-icon"/>
          </button>
        </div>
        <div class="bm-modal-body border-0">
          <div class="tabs-wrapper">
            <div class="tabs-inner">
              <ul class="list-unstyled im-tabs mb-0">
                <li>
                  <tab
                    :id="3"
                    :tab-active="selectedId"
                    title="Stock photos"/>
                </li>

                <li>
                  <tab
                    :id="4"
                    :tab-active="selectedId"
                    title="AI Images"/>
                </li>

                <li class="">
                  <tab
                    :id="2"
                    :tab-active="selectedId"
                    title="My computer"/>
                </li>
                <li class="">
                  <tab
                    :id="1"
                    :tab-active="selectedId"
                    title="My gallery"/>
                </li>
              </ul>
            </div>

            <div class="main-tabs-content">
              <div
                v-if="selectedId == 1">
                <thumbnail-box
                  ref="galleryThumbnailBox"
                  :image-data="selectedImageData"
                  :images="getMyGalleryImages"
                  :loader="galleryLoader"
                  gallery-images="gallery"/>
              </div>
              <div
                v-show="selectedId == 2"
                class="file-select">
                <file-select/>
              </div>
              <div v-if="selectedId == 3" >
                <thumbnail-box
                  ref="stockThumbnailBox"
                  :image-data="selectedImageData"
                  :images="MyStockImages"
                  :loader="stockLoader"
                  @resetStockPhotosAfterSearch="resetStockPhotosAfterSearch"
                  @searchStockPhotos="fetchStockPhotosByKeyWord"
                />
              </div>

              <div v-if="selectedId == 4" >
                <ai-images
                  @close="handleModalClose"
                />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <div
      :class="[isImageModalShown?'d-none':'' ]"
      class="backdrop position-fixed h-100 w-100"
      @click="handleModalClose"/>
  </div>
</template>
<script>

import ThumbnailBox from '@/components/ThumbnailBox/ThumbnailBox.vue';
import FileSelect from '@/components/FileSelect/FileSelect.vue';
import StockImages from '@/components/StockImages/StockImages.vue';
import Tab from '@/components/Tab/Tab.vue';
import AiImages from '@/components/AiImages/AiImages';
import EventBus from '@/EventBus';
import { mapGetters } from 'vuex';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';


export default {
  name:       'ImageModal',
  components: {
    tab:             Tab,
    'thumbnail-box': ThumbnailBox,
    'file-select':   FileSelect,
    'stock-images':  StockImages,
    'ai-images':     AiImages,
  },
  data() {
    return {
      isImageModalShown: false,
      isTabClicked:      false,
      stockLoader:       true,
      galleryLoader:     true,
      selectedId:        '3',
      isGalleryShown:    false,
      selectedImageData: {},
      MyGalleryImages:   [],
      MyStockImages:     [],
      stockImages:       {
        MaxLimit:                  20,
        LowLimit:                  0,
        isStockImagesSearchByWord: false,
        isStockImagesByDefault:    true,
        isProcessing:              false,
      },
      // stockImagesLimit:20,
      myGalleryImages:
                    {
                      MaxLimit:     20,
                      LowLimit:     0,
                      isProcessing: false,
                    },
    };
  },
  mounted() {
    if (window.screen.height > 1500 && window.screen.height <= 3000) {
      this.stockImages.MaxLimit = this.myGalleryImages.MaxLimit = 40;
    }

    if (window.screen.height > 3000 && window.screen.height <= 4500) {
      this.stockImages.MaxLimit = this.myGalleryImages.MaxLimit = 60;
    }

    if (window.screen.height > 4500) {
      this.stockImages.MaxLimit = this.myGalleryImages.MaxLimit = 80;
    }

    // code For lazy loading in Stock Images

    // code for Lazy loading in Gallery Images

    setTimeout(() => {
      this.fetchMyGalleryList();
      this.bindScrollToGalleryImages();
    }, 0);
    setTimeout(() => {
      this.fetchStockList();
    }, 0);
    EventBus.$on('AddImageNewImageToMyGalleryImages', imageData => this.MyGalleryImages.unshift(imageData));
    EventBus.$on('ondeleteImageFromMyGallary', this.deleteImageFromGallary),
    EventBus.$on('onImageSelected', (data, mood) => {
      this.selectedImageData = data;
      this.selectingImageForLefPanel();
    });

    EventBus.$on('toggleTabs', this.handleTabClick);
    EventBus.$on('AddNewImageOnCanvas', this.onAddNewImageOnCanvas);
  },
  beforeDestroy() {
    EventBus.$off('onImageSelected');
    EventBus.$off('AddNewImageOnCanvas', this.onAddNewImageOnCanvas);
  },
  methods: {

    onAddNewImageOnCanvas(imageData) {
      this.selectedImageData = imageData;
      this.selectingImageForLefPanel();
    },
    deleteImageFromGallary(imageId) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);

      const bankId    = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const userId    = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=DeleteImageFromGallery&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&id=${imageId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', this.deleteImageFromMyGallaryArrayList(imageId));
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    selectingImageForLefPanel() {
      if (this.isAddNewImageModal === true) {
        Object.keys(this.selectedImageData).length !== 0 && EventBus.$emit('onAddingNewObjectImage', this.selectedImageData);
        Object.keys(this.selectedImageData).length === 0 && alert('Please Select a Image');
        return;
      }
      Object.keys(this.selectedImageData).length !== 0 && EventBus.$emit(ApplicationEventTypes.ImageObjectEvents.SELECTED_IMAGE_FOR_LEFT_PANEL, this.selectedImageData) && this.handleModalClose();
      Object.keys(this.selectedImageData).length == 0 && alert('Please Select a Image');
    },
    handleTabClick(id) {
      this.selectedId = id;
    },
    handleModalClose() {
      const currentUploadFile = this.$store.getters['activeProduct/getCurrentUploadFile'];
      const totalUploFiles    = this.$store.getters['activeProduct/getTotalUploadFiles'];
      if (totalUploFiles === currentUploadFile) {
        EventBus.$emit('showHideLoader', false);
        this.$store.commit('activeProduct/updateTotalUploadFiles', 0);
        this.$store.commit('activeProduct/updateCurrentUploadFile', 0);

        this.$store.commit('setIsAddNewImageModal', false);
        this.$store.commit('setImageModel', false);
        this.isImageModalShown = !this.isImageModalShown;
      }
    },
    clearValue() {
      this.query     = '';
      this.isFocused = false;
    },

    typeFocus() {
      if (this.query.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    fetchMyGalleryList() {
      if (this.myGalleryImages.MaxLimit != this.myGalleryImages.LowLimit) {
        this.makeLoaderVisible('gallery');
        const urlSearchPart               = window.location.search;
        const newUrlSearchParams          = new URLSearchParams(urlSearchPart);

        const bankId = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
        const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';

        const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
        const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetMyGalleryImagesInfoNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&maximumRows=${this.myGalleryImages.MaxLimit}&startRowIndex=${this.myGalleryImages.LowLimit}`;

        const oReq = new XMLHttpRequest();
        oReq.addEventListener('load', this.loadMyGalleryImages);
        oReq.addEventListener('error', (e) => {
          this.MyGalleryImages              = [0];
          this.myGalleryImages.isProcessing = false;
          this.makeLoaderInVisible('gallery');
          console.error(e);
        });
        oReq.open('GET', url);
        oReq.send();
      } else {
        this.makeLoaderInVisible('gallery');
      }
    },
    fetchStockList() {
      if (this.stockImages.MaxLimit != this.stockImages.LowLimit && !this.stockImages.isStockImagesSearchByWord) {
        this.makeLoaderVisible();
        this.stockImages.isProcessing = true;
        const urlSearchPart           = window.location.search;
        const newUrlSearchParams      = new URLSearchParams(urlSearchPart);
        const bankId                  = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
        const domainUrl               = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
        const url                     = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetStockImagesPagedNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&maximumRows=${this.stockImages.MaxLimit}&startRowIndex=${this.stockImages.LowLimit}`;


        const oReq  = new XMLHttpRequest();
        const _this = this;
        oReq.addEventListener('load', this.loadStockImages);
        oReq.addEventListener('error', (e) => {
          this.stockImages.isProcessing = false;
          this.loadStockImagesOffline(_this.$stockImages);
          this.makeLoaderInVisible();
          console.error(e);
        });
        oReq.open('GET', url);
        oReq.send();
      }
    },
    fetchStockPhotosByKeyWord(data) {
      this.makeLoaderVisible();
      this.stockImages.isStockImagesSearchByWord = true;
      this.stockImages.isStockImagesByDefault    = false;
      const urlSearchPart                        = window.location.search;
      const newUrlSearchParams                   = new URLSearchParams(urlSearchPart);
      const bankId                               = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const domainUrl                            = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url                                  = `${this.$store.getters.getBaseUrl}/newBMC/web_service.aspx?method=SearchImagesByKeywordForBankNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&keyword=${data}`;


      const oReq  = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', this.responStockPhotosByKeyWord);
      oReq.addEventListener('error', (e) => {
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    responStockPhotosByKeyWord(data) {
      this.makeLoaderInVisible();
      const parser           = new DOMParser();
      const xmlParsed        = parser.parseFromString(data.target.response, 'text/xml');
      const imagesCollection = xmlParsed.getElementsByTagName('SearchImagesByKeywordForBankNewEditorResult')[0].innerHTML;
      this.MyStockImages     = JSON.parse(imagesCollection);
    },
    resetStockPhotosAfterSearch() {
      this.stockImages.isStockImagesSearchByWord = false;
      if (!this.stockImages.isStockImagesByDefault) {
        this.MyStockImages = [];
        this.fetchStockList();
      }
      this.stockImages.isStockImagesByDefault = true;
    },
    makeLoaderVisible(which = 'stock') {
      if (which === 'gallery') this.galleryLoader = true;
      else this.stockLoader = true;
    },
    makeLoaderInVisible(which = 'stock') {
      if (which === 'gallery') this.galleryLoader = false;
      else this.stockLoader = false;
    },
    loadMyGalleryImages(data) {
      try {
        const parser    = new DOMParser();
        const xmlParsed = parser.parseFromString(data.target.response, 'text/xml');
        console.log('xmlParsed');
        console.log(xmlParsed);
        let imagesCollection = xmlParsed.getElementsByTagName('GetMyGalleryImagesInfoNewEditorResult');
        imagesCollection     = JSON.parse(imagesCollection[0].innerHTML);
        if (this.myGalleryImages.MaxLimit < imagesCollection.nrTotal) {
          this.myGalleryImages.LowLimit  = this.myGalleryImages.MaxLimit;
          this.myGalleryImages.MaxLimit += 20;
        } else {
          this.myGalleryImages.MaxLimit = imagesCollection.nrTotal;
        }
        if (this.MyGalleryImages.length != imagesCollection.nrTotal) {
          this.MyGalleryImages = [...this.MyGalleryImages, ...imagesCollection.list];
        } else { // condition for checking the all total number of the image is called and there is no more api call needed
          this.myGalleryImages.LowLimit = 0;
          this.myGalleryImages.MaxLimit = 0;
        }
      } catch (e) {
        this.MyGalleryImages = [0];
        console.log('Error:loadMyGalleryImages/parseFromXml', e.message);
      } finally {
        this.myGalleryImages.isProcessing = false;
        this.makeLoaderInVisible('gallery');
      }
    },
    deleteImageFromMyGallaryArrayList(imgId) {
      const removeIndex = this.MyGalleryImages.findIndex((cur, index) => cur.Id == imgId);
      this.MyGalleryImages.splice(removeIndex, 1);
    },
    loadStockImages(data) {
      try {
        const parser              = new DOMParser();
        const xmlParsed           = parser.parseFromString(data.target.response, 'text/xml');
        let imagesCollection      = xmlParsed.getElementsByTagName('GetStockImagesPagedNewEditorResult');
        const totalNumberofImages = xmlParsed.getElementsByTagName('nrTotal')[0].innerHTML;
        imagesCollection[0] && (imagesCollection = imagesCollection[0].innerHTML);
        if (this.stockImages.MaxLimit < totalNumberofImages) {
          this.stockImages.LowLimit  = this.stockImages.MaxLimit;
          this.stockImages.MaxLimit += 20;
        } else {
          this.myGalleryImages.MaxLimit = totalNumberofImages;
        }
        if (this.MyGalleryImages.length != totalNumberofImages) {
          this.MyStockImages = [...this.MyStockImages, ...JSON.parse(imagesCollection)];
        } else { // conditon that tell the total number of images is called and there is no more api call needed
          this.stockImages.MaxLimit = 0;
          this.stockImages.LowLimit = 0;
        }
      } catch (e) {
        console.log('Error:loadStockImages/parseFromXml', e.message);
      } finally {
        this.stockImages.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
    loadStockImagesOffline(data) {
      try {
        // const parser = new DOMParser();
        // const xmlParsed = parser.parseFromString(data, 'text/xml');
        const imagesCollection    = data;
        const totalNumberofImages = 20;
        // imagesCollection[0] && (imagesCollection = imagesCollection[0].innerHTML);
        if (this.stockImages.MaxLimit < totalNumberofImages) {
          this.stockImages.LowLimit  = this.stockImages.MaxLimit;
          this.stockImages.MaxLimit += 20;
        } else {
          this.myGalleryImages.MaxLimit = totalNumberofImages;
        }
        if (this.MyGalleryImages.length != totalNumberofImages) {
          this.MyStockImages = JSON.parse(imagesCollection);
        } else { // conditon that tell the total number of images is called and there is no more api call needed
          this.stockImages.MaxLimit = 0;
          this.stockImages.LowLimit = 0;
        }
      } catch (e) {
        console.log('Error:loadStockImages/parseFromXml', e.message);
      } finally {
        this.makeLoaderInVisible();
      }
    },

    bindScrollToStockImages() {
      const stockImages = document.getElementById('stock-images');
      if (!stockImages) { return; }
      stockImages.onscroll = null;
      stockImages.addEventListener('scroll', () => {
        if (!this.stockImages.isProcessing && Math.round(stockImages.scrollTop + stockImages.clientHeight) >= stockImages.scrollHeight - 10) {
          this.fetchStockList();
        }
      });
    },
    bindScrollToGalleryImages() {
      const galleryImages = document.getElementById('gallery-images');
      if (!galleryImages) { return; }
      galleryImages.onscroll = null;
      galleryImages.addEventListener('scroll', () => {
        if (!this.myGalleryImages.isProcessing && Math.round(galleryImages.scrollTop + galleryImages.clientHeight) >= galleryImages.scrollHeight - 10) {
          this.fetchMyGalleryList();
        }
      });
    },
  },
  computed: {
    ...mapGetters({ isAddNewImageModal: 'getIsAddNewImageModal' }),
    getMyGalleryImages() {
      return this.MyGalleryImages;
    },
  },
  updated() {
    if (this.selectedId == 3 || this.selectedId == 1) {
      if (this.selectedId == 3) {
        this.bindScrollToStockImages();
      } else if (this.selectedId == 1) {
        this.bindScrollToGalleryImages();
      }
    }
  },
};

</script>
<style lang="scss">
    .image-modal-wrapper {
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 4000;
      .modal-inner {
        position: relative;
        z-index: 1;
      }

      .bm-image-modal-content.im-dialog {
        width: min(1008px, calc(100vw - 32px)) !important;
        min-width: 0 !important;
        max-width: calc(100vw - 32px) !important;
        height: auto !important;
        max-height: calc(100vh - 48px) !important;
        padding: 0;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 24px 64px rgba(16, 24, 40, 0.28);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 2;
        font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
        color: #14161B;
        -webkit-font-smoothing: antialiased;
      }
        .bm-modal-content {
            min-width: 600px;
            height: fit-content !important;
            width: 70vw !important;
            box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
            z-index: 99;
        }

        .bm-modal-body,
        .tabs-wrapper {
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            min-height: 0;
        }

        .im-header {
            display: flex;
            align-items: flex-start;
            flex-shrink: 0;
            gap: 12px;
            padding: 20px 20px 14px 24px;
        }

        .im-dialog .modal-heading {
            flex: 1 1 auto;
            min-width: 0;
            margin: 0;
            font-family: inherit;
            font-size: 18px;
            font-weight: 700;
            letter-spacing: -0.01em;
            line-height: 1.3;
            color: #14161B;
            text-align: left;
        }

        .im-close {
            width: 32px;
            height: 32px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0;
            border-radius: 8px;
            padding: 0;
            cursor: pointer;
            background: transparent;
            color: #3D4350;
        }

        .im-close:hover {
            background: #F3F4F6;
        }

        .im-close .icon {
            min-width: 0;
            min-height: 0;
        }

        .im-close .icon svg {
            width: 16px;
            height: 16px;
        }

        .im-tabs {
            display: flex;
            flex-shrink: 0;
            gap: 24px;
            margin: 0;
            padding: 0 24px;
            border-bottom: 1px solid #E7E9ED;
            overflow-x: auto;
        }

        .im-tabs li {
            flex: 0 0 auto;
        }

        .tabs-inner .im-tabs .tab-btns {
            width: auto;
            max-width: none;
            height: 42px;
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 0 2px !important;
            border: 0;
            background: transparent;
            box-shadow: inset 0 0 0 #1570EF;
            font-family: inherit;
            font-size: 13.5px !important;
            font-weight: 500;
            line-height: 1;
            color: #5E6573;
            white-space: nowrap;
            cursor: pointer;

            &:after {
                display: none;
            }
        }

        .tabs-inner .im-tabs .tab-active.tab-btns {
            font-weight: 650;
            color: #14161B !important;
            box-shadow: inset 0 -2px 0 #1570EF;
        }

        .im-dialog .main-tabs-content {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            gap: 16px;
            min-height: 0;
            height: min(700px, calc(100vh - 180px));
            overflow: hidden;
            padding: 20px 24px;

            > div {
                display: flex;
                flex-direction: column;
                flex: 1 1 auto;
                min-height: 0;
                overflow: auto;
            }
        }

        .action-btn {
            min-width: 100px;
        }


        .search-bar-wrapper {
            min-width: 432px;
            max-width: none !important;
        }

        .bm-input {
            /*width: 100%;*/
            box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
        }


        .images-thumbnail-wrapper {
            max-height: 356px;
            overflow-y: auto;
            display: flex;
            flex-flow: column wrap;

            &::-webkit-scrollbar {
                width: 8px;
                //margin-right: 4px;
                background-color: $grey10;
                border: 1px solid $grey20;
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                box-shadow: inset 0px 0px 5px #dddddd;
                border: none;
                border-right: 2.5px solid transparent;
                border-left: 2.5px solid transparent;
                background: transparent;
            }
        }

        .backdrop {
            background-color: rgba(237, 237, 237, 0.6);
            filter: blur(4px);
            top: 0;
            left: 0;
            z-index: 0;
        }

        .search-icon {
            left: 14px;
            top: 11px;
        }

        .close-icon {
            right: 10px;
            top: 10px;
        }

        .browse-btn {
            min-width: 125px;
        }

        .select-file-computer {
            min-height: 412px;
            border-style: dashed !important;

            .file-upload-btn {
                input {
                    opacity: 0;
                    cursor: pointer;
                    left: 0;
                    top: 0;
                }
            }
        }

        .btn-close {
            height: 16px;
            width: 16px;
            outline: 0px;

            &:focus {
                outline: 0px;
            }
        }

        .bm-modal-footer {
            margin: 0 auto;
        }

        .focused {
            .bm-input {
                border-color: $blue50 !important;
                color: $grey80;
            }

            .close-icon {
                display: block !important;
            }

            .search-icon {
                svg {
                    path {
                        stroke: #3BB0FA;
                    }
                }
            }
        }

        .remove-focus {
            &.close-icon {
                display: block !important;
            }
        }

        .remove-focus {
            &.bm-input {
                border: 1px solid #EDEDED;
            }
        }

        .bm-input {
            &:focus + {
                .search-icon {
                    svg {
                        path {
                            stroke: #3BB0FA;
                        }
                    }
                }
            }
        }

        .active-search {
            .icon {
                svg {
                    path {
                        stroke: #3BB0FA;
                    }
                }
            }
        }

        .remove-focus {
            .icon {
                svg {
                    filter: none;
                }
            }
        }
      .file-select {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
      }

      @media screen and (max-width: 720px) {
        .bm-image-modal-content.im-dialog {
          width: calc(100vw - 16px) !important;
        }

        .im-header,
        .im-dialog .main-tabs-content {
          padding-left: 16px;
          padding-right: 16px;
        }

        .im-tabs {
          padding-left: 16px;
          padding-right: 16px;
          gap: 16px;
        }

        .im-dialog .main-tabs-content {
          height: calc(100vh - 160px);
        }
      }
    }

    .close-icon-wrapper {
        .icon {
            display: inline-flex !important;
            cursor: pointer;
        }
    }


</style>
